import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * The birth list lives on the home. This page used to pitch the same thing under a near
 * identical title, and Google split the ranking between the two; a 301 hands its links
 * and history to the home.
 */
export const Route = createFileRoute("/liste-de-naissance")({
  staticData: { ssr: true },
  beforeLoad: () => {
    throw redirect({ to: "/", statusCode: 301 });
  },
});
